import {
  UIUnifiedPriceBreakdown,
  UIUnifiedPriceBreakdownAttachedAncillary,
  UIUnifiedPriceBreakdownItem
} from "@flights/types";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";

export const getAttachedAncillaries = (
  unifiedPriceBreakdown?: UIUnifiedPriceBreakdown,
  addedItems: UIUnifiedPriceBreakdownItem[] = []
): UIUnifiedPriceBreakdownAttachedAncillary[] => {
  if (!isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_UNIFIED_PRICE_BREAKDOWN_ATTACHED_ANCILLARIES")) {
    return [];
  }

  return [...(unifiedPriceBreakdown?.items || []), ...(unifiedPriceBreakdown?.addedItems || []), ...addedItems]
    .filter((breakdownItem) => breakdownItem.scope === "EXTRA")
    .reduce<UIUnifiedPriceBreakdownAttachedAncillary[]>((acc, { id, quantity }) => {
      if (id && quantity) acc.push({ id, quantity });
      return acc;
    }, []);
};
